export const PAGE_ZOOM_ATTR = 'data-page-zoom-container';

export const MAX_INSERTED_IMAGE_SIZE = 240;
